'use strict'
// MENU - OPEN
// GOOGLE MAP INNIT
// REMOVE LOADER
// NAVIGATION


/*global google*/
if (window.addEventListener) {
    window.addEventListener('load', websiteLoad)
    window.addEventListener('load', websiteLoadResize)
} else if (window.attachEvent) {
    window.attachEvent('load', websiteLoad)
    window.attachEvent('load', websiteLoadResize)
} else {
    window.onload = websiteLoad
    window.onload = websiteLoadResize
}

if (window.addEventListener) {
    window.addEventListener('resize', website_resize)
    window.addEventListener('resize', websiteLoadResize)
} else if (window.attachEvent) {
    window.attachEvent('resize', website_resize)
    window.attachEvent('resize', websiteLoadResize)
} else {
    window.onresize = website_resize
    window.onresize = websiteLoadResize
}

function websiteLoad() {
    mainNavScroll();
    menuDropdown();
    audioPlayer();
} // end websiteLoad

function website_resize() {
    menuDropdown();
}
function websiteLoadResize() {

}

// GOOGLE MAP INNIT
window.marker = null
function initialize() {
    var map
    var london = new google.maps.LatLng(51.508914, -0.133394)
    var newyork = new google.maps.LatLng(40.760858, -73.972084)
    var madrid = new google.maps.LatLng(40.43112324983605, -3.692083287693795)
    var frankfurt = new google.maps.LatLng(50.110508,8.672755)
    var paris = new google.maps.LatLng(48.8672723,2.3226695)

    var style = [
        {
            "featureType": "all",
            "elementType": "all",
            "stylers": [
                {
                    "saturation": -100
                },
                {
                    "gamma": 0.5
                }
            ]
        },
        {
            "featureType": "poi",
            "elementType": "all",
            "stylers": [
                {
                    "visibility": "off"
                }
            ]
        }
    ]

    var mapOptions = {
        // SET THE CENTER

        // SET THE MAP STYLE & ZOOM LEVEL
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        zoom: 17,
        // SET THE BACKGROUND COLOUR
        backgroundColor: '#eeeeee',
        // REMOVE ALL THE CONTROLS EXCEPT ZOOM
        panControl: false,
        scrollwheel: false,
        zoomControl: true,
        mapTypeControl: false,
        scaleControl: false,
        streetViewControl: false,
        overviewMapControl: false,
        zoomControlOptions: {
            style: google.maps.ZoomControlStyle.SMALL
        }

    }

    //CREATE A CUSTOM PIN ICON
    var marker_image = '/wp-content/themes/towerbrook/assets/images/pin.png'
    var pinIcon = new google.maps.MarkerImage(marker_image, null, null, null, new google.maps.Size(30, 42))


    var mapType = new google.maps.StyledMapType(style, { name: 'Grayscale' });
    
    var element =  document.getElementById('map-london');
    if (typeof(element) != 'undefined' && element != null) {
        
        mapOptions.center = london;
        map_lndn = new google.maps.Map(document.getElementById('map-london'), mapOptions)
        marker_lndn = new google.maps.Marker({
            position: london,
            map: map_lndn,
            icon: pinIcon
        });
        map_lndn.setMapTypeId('grey');
        map_lndn.mapTypes.set('grey', mapType);
    }

    var element =  document.getElementById('map-new-york');
    if (typeof(element) != 'undefined' && element != null) {
        
        mapOptions.center = newyork;
        map_ny = new google.maps.Map(document.getElementById('map-new-york'), mapOptions)
        marker_ny = new google.maps.Marker({
            position: newyork,
            map: map_ny,
            icon: pinIcon
        });
        map_ny.setMapTypeId('grey');
        map_ny.mapTypes.set('grey', mapType);
    }

    var element =  document.getElementById('map-madrid');
    if (typeof(element) != 'undefined' && element != null) {

        mapOptions.center = madrid;
        map_madrid = new google.maps.Map(document.getElementById('map-madrid'), mapOptions)
        marker_madrid = new google.maps.Marker({
            position: madrid,
            map: map_madrid,
            icon: pinIcon
        });
        map_madrid.setMapTypeId('grey');
        map_madrid.mapTypes.set('grey', mapType);
    }

    var element =  document.getElementById('map-frankfurt');
    if (typeof(element) != 'undefined' && element != null) {
        
        mapOptions.center = frankfurt;
        map_frankfurt = new google.maps.Map(document.getElementById('map-frankfurt'), mapOptions)
        marker_frankfurt = new google.maps.Marker({
            position: frankfurt,
            map: map_frankfurt,
            icon: pinIcon
        });
        map_frankfurt.setMapTypeId('grey');
        map_frankfurt.mapTypes.set('grey', mapType);
    }

    var element =  document.getElementById('map-paris');
    if (typeof(element) != 'undefined' && element != null) {
        
        mapOptions.center = paris;
        map_paris = new google.maps.Map(document.getElementById('map-paris'), mapOptions)
        marker_paris = new google.maps.Marker({
            position: paris,
            map: map_paris,
            icon: pinIcon
        });
        map_paris.setMapTypeId('grey');
        map_paris.mapTypes.set('grey', mapType);
    }

}

if (document.getElementsByClassName('maps').length > 0) {
    google.maps.event.addDomListener(window, 'load', initialize)
}



function mainNavScroll() {

    // checks for subnav and fires if < 1
    // if(document.getElementsByClassName('subnavigation').length < 1) {
    if (window.addEventListener) {
        window.addEventListener('scroll', navigationSlider);
    } else if (window.attachEvent) {
        window.attachEvent('scroll', navigationSlider);
    } else {
        window.onscroll = navigationSlider;
    }
    // }

    var lastScrollPosition = 0;
    function navigationSlider(event) {
        var scroll_distance = window.pageYOffset || document.documentElement.scrollTop;
        var mobile_header = document.getElementById('main-header');

        // makes the main nav into pos:fixed
        if (scroll_distance > 300) {
            if (mobile_header.classList != undefined) {
                if (!mobile_header.classList.contains('fixTop')) {
                    mobile_header.classList.add('fixTop');
                }
            } else {
                mobile_header.className += ' fixTop ';
            }
        } else {
            if (mobile_header.classList != undefined) {
                if (mobile_header.classList.contains('fixTop')) {
                    mobile_header.classList.remove('fixTop');
                }
            } else {
                var headerHasClass = (" " + mobile_header.className + " ").indexOf(" fixTop ") > -1;
                if (headerHasClass == true) {
                    mobile_header.className = mobile_header.className.replace(new RegExp('(?:^|\\s)' + 'fixTop' + '(?:\\s|$)'), ' ');
                }
            }
        }

        // adds active on scroll up
        // if(scroll_distance > 600) {
        //     var newScrollPosition = window.scrollY;
        //
        //     if (newScrollPosition < lastScrollPosition){
        //         var mobile_header_classes = mobile_header.classList;
        //         if(mobile_header_classes != undefined) {
        //             mobile_header.classList.add('active');
        //         } else {
        //             mobile_header.className += ' active ';
        //         }
        //     } else{
        //         var mobile_header_classes = mobile_header.classList;
        //         if(mobile_header_classes != undefined) {
        //             if(mobile_header.classList.contains('active')) {
        //                 mobile_header.classList.remove('active');
        //             }
        //         } else {
        //             var headerHasClass = (" " + mobile_header.className + " ").indexOf(" active ") > -1;
        //             if(headerHasClass == true) {
        //                 mobile_header.className = mobile_header.className.replace(new RegExp('(?:^|\\s)'+ 'active' + '(?:\\s|$)'), ' ');
        //             }
        //         }
        //     }
        //     lastScrollPosition = newScrollPosition;
        //
        // } else {
        //     var mobile_header_classes = mobile_header.classList;
        //     if(mobile_header_classes != undefined) {
        //         if(mobile_header.classList.contains('active')) {
        //             mobile_header.classList.remove('active');
        //         }
        //     } else {
        //         var headerHasClass = (" " + mobile_header.className + " ").indexOf(" active ") > -1;
        //         if(headerHasClass == true) {
        //             mobile_header.className = mobile_header.className.replace(new RegExp('(?:^|\\s)'+ 'active' + '(?:\\s|$)'), ' ');
        //         }
        //     }
        // }
    }

}



// NAVIGATION
function menuDropdown() {
    var mainNav = document.getElementById('menu-main-menu');
    var parents = document.querySelectorAll('.menu-item-has-children');

    for (var i = 0; i < parents.length; i++) {
        if (parents[i].parentNode == mainNav) {
            getParentSize(parents[i])
        }
    }
}

function audioPlayer(){
    // console.log('function called');
    var myAudio = document.getElementById('sound-clip');
    var play = document.getElementById('audio-play');
    var pause = document.getElementById('audio-pause');
    if (typeof(myAudio) != 'undefined' && myAudio != null) {
        // console.log('audio exists');
        play.addEventListener('click', function(event) {
            event.preventDefault();
            // console.log('play button clicked');
            myAudio.play();
            play.style.display = "none";
            pause.style.display = "block";
        });
        pause.addEventListener('click', function(event) {
            event.preventDefault();
            // console.log('pause button clicked');
            myAudio.pause();
            play.style.display = "block";
            pause.style.display = "none";
        });
        myAudio.addEventListener("ended", function() {
            // console.log('is ended');
            play.style.display = "block";
            pause.style.display = "none";
        });
    } else {
        // console.log('no audio')
    }
}

function getParentSize(parent) {
    var child = parent.querySelector('ul'),
        parent_h = parent.offsetHeight;
    if (window.innerWidth > 992 && parent.onmouseenter == null) {
        child.classList.add('reseter');
        var child_h = child.offsetHeight;
        parent.onmouseenter = function () {
            this.style.height = parent_h + child_h + 85 + 'px';
            child.style.height = child_h + 40 + 'px';
        }
        parent.onmouseleave = function () {
            this.style.height = parent_h + 'px';
            child.style.height = '0px';
        }
        child.classList.remove('reseter');
    } else {
        parent.onmouseenter = null;
        parent.onmouseleave = null;
    }
}